export default __webpack_public_path__ + "ba74d4f4aabba506393059d37636bef3.svg";